<template>
  <div class="text-center">
    <h1>Salon Has Been Created</h1>
    <a href="/">Check Your Calender For Booking</a>
  </div>
</template>
